import {
  clearPersistedState,
  type PersistConfig,
} from './signal-store-persist.util';

export const REPOSITORY_ADMIN_STORAGE_VERSION = 2;
const LEGACY_STORAGE_KEY = 'vault_repository_admin_state';

export function buildRepositoryAdminPersistKey(
  tenantId: string,
  userId: string,
): string {
  const tenant = (tenantId ?? '').trim().toLowerCase() || 'no-tenant';
  const user = (userId ?? '').trim().replace(/-/g, '').toLowerCase() || 'no-user';
  return `vault_repository_admin_state_v${REPOSITORY_ADMIN_STORAGE_VERSION}_${tenant}_${user}`;
}

export function buildRepositoryAdminPersistConfig(
  tenantId: string,
  userId: string,
): PersistConfig {
  return {
    key: buildRepositoryAdminPersistKey(tenantId, userId),
    version: REPOSITORY_ADMIN_STORAGE_VERSION,
    storage: 'session',
  };
}

/** Clave global heredada (sin usuario/tenant); se elimina al enlazar un scope nuevo. */
export function clearLegacyRepositoryAdminPersistState(): void {
  clearPersistedState({
    key: LEGACY_STORAGE_KEY,
    version: REPOSITORY_ADMIN_STORAGE_VERSION,
    storage: 'session',
  });
}

/** Limpia todos los estados de Bóveda en sessionStorage (logout / cambio de usuario). */
export function clearAllRepositoryAdminPersistState(): void {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    const keys: string[] = [];
    for (let i = 0; i < window.sessionStorage.length; i++) {
      const key = window.sessionStorage.key(i);
      if (key && key.startsWith('vault_repository_admin_state')) {
        keys.push(key);
      }
    }
    for (const key of keys) {
      window.sessionStorage.removeItem(key);
    }
  } catch {
    /* ignore */
  }
  clearLegacyRepositoryAdminPersistState();
}
